import ReactDOM from 'react-dom/client'
import App from './app.tsx'
import 'react-toastify/dist/ReactToastify.css';
import './index.css'
import './utils/i18n.tsx'
import { getContainerId } from './utils/getContainerID.tsx';
import * as Sentry from "@sentry/react";

const appVersion = import.meta.env.VITE_RELEASE_VERSION;

const renderApp = () => {
	const containerId = getContainerId();
	const container = document.getElementById(containerId);
	if (!container) {
		console.error(`Container with ID ${containerId} not found.`);
		return;
	}

	try {
		Sentry.init({
			dsn: "https://c233a76b11db68278b0a5e17662ba5eb@o4503918113783808.ingest.us.sentry.io/4508164505206784",
			defaultIntegrations: false, // Disable default integrations to avoid conflicts
			integrations: [],
			beforeSend(event) {
				if (event.exception && event.exception.values) {
					const stackFrames = event.exception.values.flatMap(value => value.stacktrace?.frames || []);
					// Check if the error is from YOUR React app
					const isFromYourApp = stackFrames.some(frame => frame.filename && frame.filename.includes(`index-v${appVersion}.js`));

					// Ignore errors if they originate from other scripts
					if (!isFromYourApp) {
						return null;
					}
				}
				return event;
			},
			tracesSampleRate: 0.5, // Adjust the sampling rate based on your requirements
			release: import.meta.env.VITE_RELEASE_VERSION,
		});
	} catch (error) {
		console.error("Error initializing Sentry:", error);
	}

	ReactDOM.createRoot(container).render(
		<App />
	);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		renderApp();
	})
} else {
	renderApp();
}
